module.exports = __webpack_public_path__ + "static/media/34DSS9.17cf4a3b.jpg";